import tmhRequest from "@/config/tmhRequest";

export default {
  searchCustomer: function(data) {
    return tmhRequest({
      url: "/customer/tmh/customer/searchcustomer",
      method: "post",
      params: data
    });
  },

  initMyHealthInfo: function(data) {
    return tmhRequest({
      url: "/customer/tmh/healthinfo/initmyhealthinfo",
      method: "post",
      params: data
    });
  },

  registerCustomer: function(data) {
    return tmhRequest({
      url: "/customer/tmh/customer/registercustomer",
      method: "post",
      params: data
    });
  },

  upgradeCustomer: function(data) {
    return tmhRequest({
      url: "/customer/tmh/customer/upgradecustomer",
      method: "post",
      params: data
    });
  },

  verifyPower: function(data) {
    return tmhRequest({
      url: "customer/tmh/customer/verifypower",
      method: "get",
      params: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/tmh/customer/healthinfo.js